export default {
  name: 'cartCounter',
  component() {
    return {
      get count() { return this.$store.cart.itemCount; },
      get loading() { return this.$store.cart.loading; }
    };
  }
};